








import Vue from 'vue';
import PageFetchHook from '@/components/mixins/PageFetchHook';
// @ts-ignore
import NewContainer from '@/containers/cvs/new.vue';
import * as CvsStore from '@/containers/cvs/store';
import store from '@/store';

const fetch = async () => {
  await Promise.all([
    store.dispatch(CvsStore.GetCvs.namespaced(null)),
    store.dispatch(CvsStore.GetCvDesignTemplateSamples.namespaced(null)),
    store.dispatch(CvsStore.GetCvExamples.namespaced(null)),
  ]);
};

export default Vue.extend({
  // NOTE: DO NOT reset state of CvsStore
  components: {
    NewContainer,
  },
  mixins: [PageFetchHook(fetch)],
});
